import { render, staticRenderFns } from "./InvestorApplyButton.vue?vue&type=template&id=364202aa&"
import script from "./InvestorApplyButton.vue?vue&type=script&lang=js&"
export * from "./InvestorApplyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports